import React, { useState, useCallback, useEffect } from 'react';
import axios from '../../axiosInstance';
import { useLocation, useNavigate, useSearchParams, Link } from 'react-router-dom';
import FilterTags1 from '../../components/FilterTags1';
import Pagination from '../../components/Pagination';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha'; // For Alphabetical Sort
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'; // For Latest Sort
import StarsIcon from '@mui/icons-material/Stars'; // For Relevance Sort
import Facets from '../../components/Facets';
import defaultThumbnail from '../../assets/logo4.png';
import { useTheme } from '@mui/material/styles';
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import Input from '../../components/ui/Input';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';
import ReactGA from 'react-ga';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';


import {
  Typography,
  Box,
  Modal,
  Paper,
  IconButton, 
  Tabs,
  Tab,
  useMediaQuery,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';



// Register the required components
ChartJS.register(ArcElement, Tooltip, Legend);  



// Function to convert search results to CSV format
const convertResultsToCSV = (results) => {
  const headers = ['Title', 'Abstract', 'Authors', 'Year', 'Source'];
  const rows = results.map(result => [
    `"${result.title}"`,
    `"${result.abstract}"`,
    `"${result.authors}"`,
    `"${result.year}"`,
    `"${result.source}"`,
  ]);

  const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
  return csvContent;
};

// Function to handle download
const handleDownload = (results) => {
  const csvData = convertResultsToCSV(results);
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'search_results.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



const MyLibrary = ({ onSearch, initialQuery }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [bookIdsWithChapters, setBookIdsWithChapters] = useState(new Set());

  const [openAiSuggestions, setOpenAiSuggestions] = useState([]);
const [lastSearch, setLastSearch] = useState('');
const user = JSON.parse(localStorage.getItem("user"));

  const queryFromUrl = new URLSearchParams(location.search).get('query') || '';
  const filtersFromUrl = Object.fromEntries(
    new URLSearchParams(location.search).entries()
  );



  const isMobile = useMediaQuery('(max-width:768px)'); // Adjust breakpoint as needed
  const [tabValue, setTabValue] = useState(0);
  


  const extractedFilters = {};
  Object.keys(filtersFromUrl).forEach(param => {
    if (param.startsWith('f.')) {
      const facetName = param.replace('f.', '');
      const value = filtersFromUrl[param].split(',')[0]; // Extract value
      extractedFilters[facetName] = value;
    }
  });
  
  const [query, setQuery] = useState(queryFromUrl);

  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // State to control modal open/close
  const [selectedArticleId, setSelectedArticleId] = useState(null); // State to store selected article ID
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [viewMode, setViewMode] = useState('list');
  const [sortOrder, setSortOrder] = useState('relevance');
  const [selectedSort, setSelectedSort] = useState({ field: 'score', direction: 'DESC' });

  // Add state for facets and selected filters
const [facets, setFacets] = useState({});
const [selectedFilters, setSelectedFilters] = useState({});


  const theme = useTheme(); // Access the theme

    // Check if user is logged in using localStorage
    const userLoggedIn = localStorage.getItem('token') ? true : false;
    
  const resultsPerPage = 20; // Define results per page


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue); // Change active tab
  };

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [notifications, setNotifications] = useState([
      { id: 1, message: "New book added to your course", read: false },
      { id: 2, message: "Your library subscription expires soon", read: false }
    ]);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const unreadCount = notifications.filter((n) => !n.read).length;
  
    const [username, setUsername] = useState(null); // Store the username
    const [displayname, setDisplayname] = useState(null); // Store the username
    const [courseIds, setCourseIds] = useState(null); // Store the username
    const [collegeId, setCollegeId] = useState(null); // Store the username
    const [inputValue, setInputValue] = useState(initialQuery || '');

  
      // Function to handle the search action
     // Function to handle the search action
     const handleSearch = () => {
      const query = (inputValue || "").trim();
    
      if (!query) {
        alert("Please enter a search term.");
        return;
      }
  
      // Navigate to the correct URL
      navigate(`/mylibrary?query=${encodeURIComponent(query)}`, {
        state: { query },
      });
    };
    
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setUsername(user.username);  // Set username if user is logged in
        setCourseIds(user.courseIds);
        setCollegeId(user.collegeId);
        setDisplayname(user.displayname);
      }
    }, []);
  
  
    const handleClear = () => {
      setInputValue('');
    };
  
    const handleLogout = () => {
      // Clear the token and user from localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
  
      // Redirect the user to the login page
      navigate('/');
    };

    const FACET_KEY_MAP = {
      coursename: 'courseName',
      booktype: 'bookType',
      semester: 'semester',
      subjectname: 'subjectName',
      publishername: 'publisherName',
      booklanguage: 'bookLanguage',
    };

    
    const fetchResults = useCallback(
      async (searchQuery, pageNumber = 1, filters = {}, sorting = selectedSort) => {
        setLoading(true);
        setError(null);
    
        try {
          const activeFilters = {};
          for (const key in filters) {
            const mappedKey = FACET_KEY_MAP[key.toLowerCase()] || key;
            const value = filters[key];
            activeFilters[mappedKey] = Array.isArray(value)
              ? value.map((v) => v.replace(/,$/, ''))
              : [value.replace(/,$/, '')];
          }
    
          const params = {
            collegeId: userLoggedIn ? JSON.parse(localStorage.getItem('user')).collegeId : null,
            query: searchQuery,
            sortBy: sorting.field || 'bookTitle',
            order: sorting.direction || 'asc',
            page: pageNumber,
            limit: resultsPerPage,
            ...activeFilters
          };
    
          const response = await axios.get(`https://backend.scholarkart.in/api/books/search-college`, { params });
    
          const books = response.data.books || [];
          const totalBooks = response.data.total || 0;
    
          if (totalBooks === 0) {
            setResults([]);
            setFilteredResults([]);
            setTotalResults(0);
            setTotalPages(0);
            setError("No books found matching your criteria.");
            return;
          }
    
          const formattedResults = books.map((book) => ({
            id: book._id || "No ID available",
            title: book.bookTitle || "No title available",
            abstract: book.bookdescription || "No description available",
            authors: book.authorName || "Unknown",
            year: book.publicationYear || "Unknown",
            type: book.bookType || "Unknown",
            publisher: book.publisherName || "Unknown",
            language: book.bookLanguage || "Unknown",
            course: book.courseDetails?.courseId?.courseName || "Unknown",
            subject: book.courseDetails?.subjectId?.subjectName || "Unknown",
            semester: book.courseDetails?.semester || "Unknown",
            source: "eBooks",
            detailLink: book.pdfURL || "#",
            thumbnail: book.coverImageURL || defaultThumbnail,
          }));
    
          setResults(formattedResults);
          setFilteredResults(formattedResults);
          setTotalResults(totalBooks);
          setTotalPages(Math.ceil(totalBooks / resultsPerPage));
        } catch (error) {
          console.error("Error fetching book data:", error);
          setResults([]);
          setTotalResults(0);
          setTotalPages(0);
          setError("Error fetching results. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      [query, page, selectedSort]
    );
    



    const fetchFacets = useCallback(async (searchQuery, filters = {}) => {
      try {
        const collegeId = userLoggedIn ? JSON.parse(localStorage.getItem('user')).collegeId : null;
        if (!collegeId) {
          console.error("No College ID found for the user.");
          return;
        }
    
        const params = new URLSearchParams();
        params.append('collegeId', collegeId);
        if (searchQuery) {
          params.append('query', searchQuery);
        }
    
        Object.entries(filters).forEach(([key, value]) => {
          const mappedKey = FACET_KEY_MAP[key.toLowerCase()] || key;
          if (Array.isArray(value)) {
            value.forEach((v) => params.append(mappedKey, v.replace(/,$/, '')));
          } else {
            params.append(mappedKey, value.replace(/,$/, ''));
          }
        });
    
        const response = await axios.get(`https://backend.scholarkart.in/api/books/facets?${params.toString()}`);
        const facetData = response.data;
    
        const newFacets = {
          courseName: {},
          bookType: {},
          semester: {},
          bookLanguage: {},
          subjectName: {},
          publisherName: {},
        };
    
        Object.keys(facetData).forEach((facetKey) => {
          facetData[facetKey].forEach((facet) => {
            if (facet._id) {
              newFacets[facetKey][facet._id] = facet.count;
            }
          });
        });
    
        setFacets(newFacets);
      } catch (error) {
        console.error("Error fetching facet data:", error);
      }
    }, []);
    



// Update onFacetChange to modify the URL with selected filters
const onFacetChange = (facetName, value) => {
  const currentValues = selectedFilters[facetName] || [];

  let updatedValues;
  if (currentValues.includes(value)) {
    // Deselect
    updatedValues = currentValues.filter((v) => v !== value);
  } else {
    // Select
    updatedValues = [...currentValues, value];
  }

  const updatedFilters = { ...selectedFilters, [facetName]: updatedValues };
  if (updatedValues.length === 0) delete updatedFilters[facetName];

  setSelectedFilters(updatedFilters);

  // Update URL
  const searchParams = new URLSearchParams();
  searchParams.set("query", query);

  Object.entries(updatedFilters).forEach(([key, values]) => {
    values.forEach((val) => {
      searchParams.append(`f.${key.toLowerCase()}`, `${val},`);
    });
  });

  navigate(`/mylibrary?${searchParams.toString()}`);
};





      // Function to remove a filter
      const removeFilter = (facetName, value) => {
        const updatedFilters = { ...selectedFilters };
        updatedFilters[facetName] = updatedFilters[facetName].filter((v) => v !== value);
        if (updatedFilters[facetName].length === 0) {
          delete updatedFilters[facetName];
        }
      
        const searchParams = new URLSearchParams();
        searchParams.set("query", query);
        Object.entries(updatedFilters).forEach(([key, values]) => {
          values.forEach((val) => {
            searchParams.append(`f.${key.toLowerCase()}`, `${val},`);
          });
        });
      
        navigate(`/mylibrary?${searchParams.toString()}`);
      };
      




      const calculateRange = () => {
        const startIndex = (page - 1) * resultsPerPage + 1;
        const endIndex = Math.min(page * resultsPerPage, totalResults);
        return `${startIndex}-${endIndex}`;
      };

      const handlePageChange = (newPage) => {
        const currentParams = new URLSearchParams(location.search);
        currentParams.set("page", newPage);
        navigate(`${location.pathname}?${currentParams.toString()}`);
      };
      

  
// Refetch results when query or page changes
useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get("query") || "";
  const currentPage = parseInt(searchParams.get("page")) || 1;

  const filters = {};
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("f.")) {
      const facetKey = key.slice(2); // Remove 'f.'
      const cleanValue = value.replace(/,$/, '');
      if (!filters[facetKey]) filters[facetKey] = [];
      filters[facetKey].push(cleanValue);
    }
  }
  

  setQuery(searchQuery);
  setPage(currentPage);
  setSelectedFilters(filters);

  fetchResults(searchQuery, currentPage, filters);
  fetchFacets(searchQuery, filters);
}, [location.search]);

  
// 🔁 Inside useEffect, right after component mounts:
useEffect(() => {
  const savedFilters = JSON.parse(localStorage.getItem('mylibrary_filters')) || {};
  const savedQuery = localStorage.getItem('mylibrary_query') || '';
  const savedPage = parseInt(localStorage.getItem('mylibrary_page')) || 1;

  if (savedQuery) {
    setQuery(savedQuery);
    setLastSearch(savedQuery);
  }
  if (Object.keys(savedFilters).length) setSelectedFilters(savedFilters);
  setPage(savedPage);

  fetchResults(savedQuery, savedPage, savedFilters);
  fetchFacets(savedQuery, savedFilters);
}, []);

// 🔁 Save filters to localStorage when they change:
useEffect(() => {
  localStorage.setItem('mylibrary_filters', JSON.stringify(selectedFilters));
}, [selectedFilters]);

useEffect(() => {
  localStorage.setItem('mylibrary_query', query);
}, [query]);

useEffect(() => {
  localStorage.setItem('mylibrary_page', page);
}, [page]);


useEffect(() => {
  if (!user?.collegeId) {
    navigate('/mycourse');
  }
}, [user]);


const handleSortChange = (newSortOrder) => {
  setSortOrder(newSortOrder);

  let sortField = 'score';
  let sortDirection = 'DESC';

  if (newSortOrder === 'alphabetical') {
    sortField = 'dc.title';
    sortDirection = 'ASC';
  } else if (newSortOrder === 'latest') {
    sortField = 'dc.date.issued';
    sortDirection = 'DESC';
  }

  setSelectedSort({ field: sortField, direction: sortDirection });

  fetchResults(query, page, selectedFilters, { field: sortField, direction: sortDirection });
};

  


const SearchResultsWrapper = styled(Box)(({ theme }) => ({
  width: '60%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 5,
    paddingRight: 5,
  },
}));

const YouTubeResultsWrapper = styled(Box)(({ theme }) => ({
  width: '40%', // Default for larger screens
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  minHeight: '500px',
  [theme.breakpoints.down('md')]: {
    width: '100%', // Full width on medium screens or smaller
    paddingLeft: 0,
  },
}));

  
// Function to handle title click
const onTitleClick = async (result) => {
  trackButtonClick(result.title);

  if (!userLoggedIn) {
    localStorage.setItem('redirectAfterLogin', JSON.stringify(result)); // Store clicked article details
    return;
  }

  try {
    const chapterRes = await axios.post(`https://backend.scholarkart.in/api/bookchapters/exist`, {
      bookIds: [result.id],
    });

    const chapterSet = new Set(chapterRes.data.bookIdsWithChapters);
    setBookIdsWithChapters(prev => new Set([...prev, ...chapterSet]));

    if (chapterSet.has(result.id)) {
      navigate(`/book/${result.id}`);  // 📚 Chapter-wise view
    } else {
      navigate(`/mylibrary/${result.id}`); // 📘 Full PDF view
    }
  } catch (error) {
    console.error("Error checking chapters:", error);
    // fallback if API fails
    navigate(`/mylibrary/${result.id}`);
  }
};



const trackButtonClick = (buttonName) => {
  console.log(`Button clicked: ${buttonName}`);
  localStorage.setItem("lastButtonClicked", buttonName);
  ReactGA.event({
    category: 'User',
    action: 'Clicked Button or Link',
    label: buttonName,
  });
};

const handleLinkClick = (linkName) => {
  trackButtonClick(linkName); // Track the hyperlink click
};

const [articleSource, setArticleSource] = useState(''); // Track article source type

useEffect(() => {
  // Initialize GA4 with your Measurement ID
  ReactGA.initialize('G-VCY1JDQLEP'); // Replace with your GA4 Measurement ID
  
  // Track page view
  ReactGA.send('pageview');
}, []);

  return (


  <main className="flex-grow p-1">

    <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">
    {collegeId && 
      <div className="relative w-full max-w-lg">
                      <Input
                        placeholder="Search my library content..."
                        className="pl-10"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') handleSearch();
                        }}
                      />
        <FaSearch className="absolute left-3 top-3 text-gray-500" />
      </div>
    }
      <div className="flex items-center space-x-4 relative">
      <Notification />
      <Profile />
      </div>
    </div>




  {loading ? (
    <p>Loading books...</p>
) : error ? (
    <p style={{ color: 'red', textAlign: 'center', fontSize: '18px' }}>{error}</p>
) : results.length > 0 ? (
    <>

    </>
) : (
    <p style={{ textAlign: 'center', fontSize: '18px', color: 'gray' }}>No books found matching your criteria.</p>
)}    


{isMobile ? (
          <>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              sx={{ marginBottom: '16px' }}
            >
              <Tab label="Search Results" />
              <Tab label="Search Filters" />
            </Tabs>

            {tabValue === 0 && (
              
              <Box sx={{ width: '100%', alignItems: 'center', }}>
                <SearchResultsWrapper>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <Typography
                      variant="h7"
                      color="primary.main"
                      sx={{ fontWeight: 'bold' }}
                    >
                      {`Showing ${calculateRange()} of ${totalResults.toLocaleString()} books`}
                    </Typography>
                    </Box>
                    
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                    <IconButton
                        onClick={() => handleSortChange('relevance')}
                        title="Sort by Relevance"
                      >
                        <StarsIcon /> {/* Use appropriate icon */}
                      </IconButton>
                    <IconButton
                        onClick={() => handleSortChange('alphabetical')}
                        title="Sort Alphabetically"
                      >
                        <SortByAlphaIcon /> {/* Use appropriate icon */}
                      </IconButton>
                      <IconButton
                        onClick={() => handleSortChange('latest')}
                        title="Sort by Latest"
                      >
                        <CalendarTodayIcon /> {/* Use appropriate icon */}
                      </IconButton>

                      <IconButton onClick={() => handleDownload(filteredResults)}>
                        <DownloadIcon />
                      </IconButton>
                    </Box>
                  

                  {/* Render Search Results */}
                  
                  {results.map((result) => (
                    <Paper
                      key={result.title}
                      sx={{
                        padding: '16px',
                        marginBottom: '12px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease-in-out',
                        width: '92%',
                        border: '1px solid transparent',
                        '&:hover': {
                          backgroundColor: '#f0f8ff',
                          borderColor: '#007bff',
                        },
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        <img
                          src={result.thumbnail || defaultThumbnail}
                          alt="Thumbnail"
                          style={{
                            width: '80px',
                            height: '120px',
                            marginRight: '16px',
                          }}
                        />
                        <Box>
                          <Typography
                            variant="h6"
                            sx={{
                              cursor: 'pointer',
                              color: 'primary.main',
                            }}
                            onClick={() => onTitleClick(result)}
                            // onClick={() => handleLinkClick(result.title)}
                          >
                            {result.title}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {`Authors: ${result.authors}`}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {`Year: ${result.year}`} | {`Published by: ${
                              result.publisher || 'N/A'
                            }`}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {`Subject: ${result.subject || 'N/A'}`}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  ))}
                  <Pagination
                    page={page}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </SearchResultsWrapper>
              </Box>
            )}

            {tabValue === 1 && (
              <Box sx={{ 
                width: '98%',
                marginLeft: '5px',
                alignItems: 'center',
                }}
              >
                <YouTubeResultsWrapper>
                  <Paper
                    elevation={0}
                    sx={{
                      marginTop: '40px',
                      backgroundColor: 'transperant',
                    }}
                  >
                    <Paper
                      sx={{
                        padding: '16px',
                        marginBottom: '12px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease-in-out', // Smooth transition
                        border: '1px solid transparent', // Default border
                        '&:hover': {
                          backgroundColor: '#f0f8ff', // Change to your desired hover color
                          borderColor: '#007bff', // Optional: Change border color on hover
                        },
                      }}
                    >
                  <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', marginBottom: '16px' }}>
                    {totalResults.toLocaleString()} Books
                  </Typography>
                  </Paper>

                    <FilterTags1
                      selectedFilters={selectedFilters}
                      removeFilter={removeFilter}
                      facets={facets} // Pass facets data
                    />

                    <Facets
                      facets={facets}
                      selectedFacets={selectedFilters}
                      onFacetChange={onFacetChange}
                    />
                  </Paper>
                </YouTubeResultsWrapper>
              </Box>
            )}
          </>
        ) : (



<Box className="main-content" display="flex">
  {/* Left Section: Search Results */}
  <SearchResultsWrapper>

  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      paddingBottom: '2px',
      paddingTop: '20px',
      gap: '2px',
        }}
    >

      <Typography variant="h7" color="primary.main" sx={{ fontWeight: 'bold' }}>
        {`Showing ${calculateRange()} of ${totalResults.toLocaleString()} books`}
      </Typography>
      
      <Box sx={{ position: 'relative', zIndex: 1000 }}> {/* Increase zIndex */}
      <IconButton
          onClick={() => handleSortChange('relevance')}
          title="Sort by Relevance"
        >
          <StarsIcon /> {/* Use appropriate icon */}
        </IconButton>
      <IconButton
          onClick={() => handleSortChange('alphabetical')}
          title="Sort Alphabetically"
        >
          <SortByAlphaIcon /> {/* Use appropriate icon */}
        </IconButton>
        <IconButton
          onClick={() => handleSortChange('latest')}
          title="Sort by Latest"
        >
          <CalendarTodayIcon /> {/* Use appropriate icon */}
        </IconButton>

        <IconButton onClick={() => handleDownload(filteredResults)}>
          <DownloadIcon />
        </IconButton>
      </Box>
    </Box>

    {/* Render Search Results */}
    {results.map((result) => (
      <Paper
        key={result.title}
        sx={{
          padding: '16px',
          marginBottom: '12px',
          borderRadius: '8px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease-in-out', // Smooth transition
          border: '1px solid transparent', // Default border
          '&:hover': {
            backgroundColor: '#f0f8ff', // Change to your desired hover color
            borderColor: '#007bff', // Optional: Change border color on hover
          },
        }}
      >
        <Box display="flex" alignItems="center">
          <img
            src={result.thumbnail || defaultThumbnail}
            alt="Thumbnail"
            style={{ 
              width: '80px', 
              height: '120px', 
              marginRight: '16px',

            }}
            
          />
          <Box>
          <Typography
              variant="h6"
              sx={{
                cursor: 'pointer', // Ensures the pointer cursor is shown
                color: 'primary.main', // Use Material-UI's primary color
              }}
              onClick={() => onTitleClick(result)}
              // onClick={() => handleLinkClick(result.title)}
            >
              {result.title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {`Authors: ${result.authors}`}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {`Year: ${result.year}`} | {`Published by: ${result.publisher || 'N/A'}`}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {`Subject: ${result.subject || 'N/A'}`}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {`Course: ${result.course || 'N/A'}`}, {result.semester || 'N/A'}
            </Typography>
          </Box>
        </Box>
      </Paper>
    ))}

{totalPages > 1 && (
    <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
    />
)}

  </SearchResultsWrapper>

  <YouTubeResultsWrapper>
  <Paper 
    elevation={0} 
    sx={{ 
      marginTop: '62px', 
      backgroundColor: 'transparent',
      }}>

                    <Paper
                      sx={{
                        padding: '16px',
                        marginBottom: '12px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease-in-out', // Smooth transition
                        border: '1px solid transparent', // Default border
                        '&:hover': {
                          backgroundColor: '#f0f8ff', // Change to your desired hover color
                          borderColor: '#007bff', // Optional: Change border color on hover
                        },
                      }}
                    >
                  <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', marginBottom: '16px' }}>
                    {totalResults.toLocaleString()} Books
                  </Typography>
                  </Paper>


    <FilterTags1
      selectedFilters={selectedFilters}
      removeFilter={removeFilter}
      facets={facets} // Pass facets data
    />

 



    <Facets
      facets={facets}
      selectedFacets={selectedFilters}
      onFacetChange={onFacetChange}
    />
  </Paper>
</YouTubeResultsWrapper>


        </Box>
)}
    </main>

  );
};

MyLibrary.propTypes = {
  query: PropTypes.string.isRequired,
};

export default MyLibrary;
